<template>
    <div class="live-detail">
        <van-nav-bar title="直播详情" left-arrow @click-left="onBack" />

        <div v-if="detail.id" class="content">
            <div class="video-card">
                <video
                    v-if="detail.video_url"
                    class="video-player"
                    :src="detail.video_url"
                    controls
                    playsinline
                    webkit-playsinline
                    preload="metadata"
                ></video>
                <div v-else class="video-empty">
                    <van-empty description="暂无视频地址" />
                </div>
            </div>

            <van-cell-group inset class="base-card">
                <van-cell>
                    <template #title>
                        <div class="title-row">
                            <span class="live-name">{{ detail.name || "-" }}</span>
                            <van-tag type="primary" plain>{{
                                detail.live_status_text || "-"
                            }}</van-tag>
                        </div>
                    </template>
                </van-cell>
                <van-cell title="直播类型" :value="detail.live_type_text || '-'" />
                <van-cell title="播放方向" :value="detail.play_type_text || '-'" />
                <van-cell title="直播房间号" :value="detail.room_number || '-'" />
                <van-cell title="开始时间" :value="detail.start_time || '-'" />
                <van-cell title="结束时间" :value="detail.end_time || '-'" />
                <van-cell title="视频时长" :value="detail.video_duration_text || detail.video_duration || '-'" />
                <van-cell title="视频大小" :value="detail.video_size ? detail.video_size + 'MB' : '-'" />
                <van-cell title="观看人数" :value="String(detail.user_view_count || 0)" />
            </van-cell-group>

            <van-cell-group inset class="extra-card">
                <van-cell title="直播说明" :label="detail.tip || '暂无说明'" />
                <van-cell title="直播状态" :value="detail.live_status_text || '-'" />
                <van-cell title="是否支持回放" :value="detail.is_replay_text || '-'" />
                <van-cell title="是否绑定课程" :value="detail.is_bind_text || '-'" />
                <van-cell title="答题开关" :value="Number(detail.is_open_question) === 1 ? '开启' : '关闭'" />
                <van-cell title="答题时间点" :value="detail.question_time || '-'" />
            </van-cell-group>
        </div>

        <div v-else class="empty-wrap">
            <van-empty description="未找到直播数据，请返回重试" />
            <van-button type="primary" size="small" @click="onBack">返回</van-button>
        </div>
    </div>
</template>

<script>
export default {
    name: "liveDetail",
    data() {
        return {
            detail: {},
        };
    },
    created() {
        this.loadDetail();
    },
    methods: {
        loadDetail() {
            const cache = localStorage.getItem("liveDetailItem");
            if (!cache) {
                this.detail = {};
                return;
            }
            try {
                this.detail = JSON.parse(cache) || {};
            } catch (e) {
                this.detail = {};
            }
        },
        onBack() {
            this.$router.back();
        },
    },
};
</script>

<style lang="less" scoped>
.live-detail {
    min-height: 100vh;
    background: #f7f8fa;
}

.content {
    padding: var(--base-px-12);
}

.video-card {
    background: #fff;
    border-radius: var(--base-px-10);
    overflow: hidden;
    margin-bottom: var(--base-px-12);
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.04);
}

.video-player {
    width: 100%;
    height: 220px;
    display: block;
    background: #000;
}

.video-empty {
    padding: var(--base-px-16) 0;
}

.base-card,
.extra-card {
    margin-bottom: var(--base-px-12);
    border-radius: var(--base-px-10);
    overflow: hidden;
}

.title-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: var(--base-px-8);
}

.live-name {
    font-size: var(--base-px-16);
    font-weight: 600;
    color: #333;
    line-height: 1.4;
}

.empty-wrap {
    min-height: calc(100vh - var(--base-px-46));
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: var(--base-px-12);
}
/deep/ .van-cell-group--inset {
    margin: 0 0 12px !important;
}
</style>